import { I18n } from 'react-redux-i18n';

import { I18N_BASE } from '../constants';
import { subjectIdSegment, SubjectIdSource } from './subjectId';

export interface MinimalClusterItem extends SubjectIdSource {
  pageNameSnapshot?: string | null;
  contentModerationEventId?: number | null;
}

// Format used in cluster lists (block modal duplicates + review screen
// body-hash cluster). The leading segment is always the subject id with its
// translated kind label ("Fundraiser #9823"); when the page name snapshot is
// also populated, append it after a dash separator
// ("Fundraiser #9823 - Charity Run 2026").
//
// Falls back gracefully when the subject id is missing (older / partial
// payloads): translated kind + moderation event id, then just the translated
// kind, then a generic unknown label.
export function clusterItemLabel(item: MinimalClusterItem): string {
  const subject = subjectIdSegment(item);

  if (subject) {
    const lead = I18n.t(subject.i18nKey, { id: subject.id });
    return item.pageNameSnapshot ? `${lead} - ${item.pageNameSnapshot}` : lead;
  }

  // No subject id — try the moderation event id with translated kind, then
  // just the kind. Page name (if present) still gets appended.
  const kindLabel = item.subjectKind
    ? I18n.t(`${I18N_BASE}.subjectKind.${item.subjectKind}`)
    : I18n.t(`${I18N_BASE}.detail.bodyHash.unknownKind`);

  const eventId = item.contentModerationEventId;
  const base = eventId != null
    ? I18n.t(`${I18N_BASE}.queue.card.fallbackTitle`, { kind: kindLabel, id: eventId })
    : kindLabel;

  return item.pageNameSnapshot ? `${base} - ${item.pageNameSnapshot}` : base;
}
